import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IconsStyles {
  getDeviceStatusIcon(deviceStatus: string): string {
    switch (deviceStatus) {
      case 'ONLINE':
        return 'pi pi-check-circle';
      case 'OFFLINE':
      case 'TIMEOUT':
        return 'pi pi-arrow-circle-down';
      case 'SECONDARY':
        return 'pi pi-check-circle';
      case 'NEW':
        return 'pi pi-plus-circle';
      case 'DEACTIVATED':
        return 'pi pi-ban';
      case 'OFF':
      default:
        return 'pi pi-circle-off';
    }
  }

  getDeviceStatusBackgroundStyle(deviceStatus: string): string {
    switch (deviceStatus) {
      case 'ONLINE':
        return 'background: rgba(0, 128, 0, 0.5);';
      case 'OFFLINE':
      case 'TIMEOUT':
        return 'background: rgba(255, 0, 0, 0.5)';
      case 'SECONDARY':
        return 'background: rgba(255, 165, 0, 0.5)';
      case 'NEW':
        return 'background: rgba(250, 212, 107, 0.5)';
      case 'DEACTIVATED':
        return 'background: rgba(128, 128, 128, 0.25)';
      case 'OFF':
      default:
        return 'background: rgba(128, 128, 128, 0.75)';
    }
  }

  getActiveIcon(status: boolean): string {
    return status ? 'pi pi-check' : 'pi pi-times';
  }

  getActiveStyle(status: boolean): string {
    return status ? 'color: green' : 'color: red';
  }

  // TODO: Change back...
  /**
   *   getRoleIcon(role: number): string {
    switch (role) {
      case 2:
        return 'pi pi-gauge';
      case 3:
        return 'fa-solid fa-solar-panel';
      case 4:
        return 'fa-solid fa-plug';
      case 5:
        return 'fa-solid fa-battery-full';
      default:
        return 'fa-solid fa-question';
    }
  }
   */
  getRoleIcon(role: number): string {
    switch (role) {
      case 1:
        return 'pi pi-gauge';
      case 2:
        return 'fa-solid fa-solar-panel';
      case 3:
        return 'fa-solid fa-plug';
      case 4:
        return 'fa-solid fa-battery-full';
      default:
        return 'fa-solid fa-question';
    }
  }

  getStateOfChargeIcon(stateOfCharge: number): string {
    if (stateOfCharge > 80) {
      return 'fa-solid fa-battery-full';
    } else if (stateOfCharge > 60) {
      return 'fa-solid fa-battery-three-quarters';
    } else if (stateOfCharge > 40) {
      return 'fa-solid fa-battery-half';
    } else if (stateOfCharge > 20) {
      return 'fa-solid fa-battery-quarter';
    } else {
      return 'fa-solid fa-battery-empty';
    }
  }

  getLockIcon(locked: boolean): string {
    return locked ? 'fa-solid fa-lock' : 'fa-solid fa-lock-open';
  }

  getOpacityStyle(deviceStatus: string): string {
    switch (deviceStatus) {
      case 'ONLINE':
        return 'opacity: 1;';
      case 'TIMEOUT':
      default:
        return 'opacity: 0.4;';
    }
  }
}
